// src/state/settings/location/types.ts
var EPrinterStatus = /* @__PURE__ */ ((EPrinterStatus2) => {
  EPrinterStatus2["ACTIVE"] = "active";
  EPrinterStatus2["MISSING_PAPER"] = "missing_paper";
  EPrinterStatus2["PRINTER_ERROR"] = "printer_error";
  EPrinterStatus2["COVER_OPEN"] = "cover_open";
  EPrinterStatus2["PAUSED"] = "paused";
  EPrinterStatus2["PRINTER_OFFLINE"] = "printer_offline";
  return EPrinterStatus2;
})(EPrinterStatus || {});
var EPrinterType = /* @__PURE__ */ ((EPrinterType2) => {
  EPrinterType2["KITCHEN"] = "kitchen";
  EPrinterType2["RECEIPT"] = "receipt";
  return EPrinterType2;
})(EPrinterType || {});
var TaxType = /* @__PURE__ */ ((TaxType2) => {
  TaxType2["PERCENT"] = "percent";
  TaxType2["TABLE"] = "table";
  TaxType2["FIXED"] = "fixed";
  TaxType2["VOLUMETRIC"] = "volume";
  return TaxType2;
})(TaxType || {});
var VolumeUnitType = /* @__PURE__ */ ((VolumeUnitType2) => {
  VolumeUnitType2["FL_OZ"] = "flOz";
  VolumeUnitType2["ML"] = "ml";
  VolumeUnitType2["L"] = "l";
  VolumeUnitType2["GAL"] = "gal";
  VolumeUnitType2["QT"] = "qt";
  VolumeUnitType2["PNT"] = "pnt";
  return VolumeUnitType2;
})(VolumeUnitType || {});
var WeightUnitType = /* @__PURE__ */ ((WeightUnitType2) => {
  WeightUnitType2["KG"] = "kg";
  WeightUnitType2["G"] = "g";
  WeightUnitType2["OZ"] = "oz";
  WeightUnitType2["LB"] = "lb";
  return WeightUnitType2;
})(WeightUnitType || {});
var EPrinterJobStatus = /* @__PURE__ */ ((EPrinterJobStatus2) => {
  EPrinterJobStatus2["PENDING"] = "pending";
  EPrinterJobStatus2["ERROR"] = "error";
  EPrinterJobStatus2["IN_TRANSIT"] = "inTransit";
  EPrinterJobStatus2["COMPLETE"] = "complete";
  return EPrinterJobStatus2;
})(EPrinterJobStatus || {});
var EPrinterJobType = /* @__PURE__ */ ((EPrinterJobType2) => {
  EPrinterJobType2["CHECK"] = "check";
  EPrinterJobType2["RECEIPT"] = "receipt";
  EPrinterJobType2["KITCHEN"] = "kitchen";
  EPrinterJobType2["FIRE"] = "fire";
  return EPrinterJobType2;
})(EPrinterJobType || {});
var SET_LOCATION_SETTINGS = "SET_LOCATION_SETTINGS";
var SET_LOCATION_SETTINGS_WS = "SET_LOCATION_SETTINGS_WS";
var SET_PRINTER_STATUS_WS = "SET_PRINTER_STATUS_WS";
var SET_PRINTERS = "SET_PRINTERS";
var REMOVED_PRINTER = "REMOVED_PRINTER";
var REMOVED_PRINTER_WS = "REMOVED_PRINTER_WS";
var SET_SETTINGS_DASHBOARDS = "SET_SETTINGS_DASHBOARDS";
var SET_ROLE_DASHBOARDS = "SET_ROLE_DASHBOARDS";

export { EPrinterJobStatus, EPrinterJobType, EPrinterStatus, EPrinterType, REMOVED_PRINTER, REMOVED_PRINTER_WS, SET_LOCATION_SETTINGS, SET_LOCATION_SETTINGS_WS, SET_PRINTERS, SET_PRINTER_STATUS_WS, SET_ROLE_DASHBOARDS, SET_SETTINGS_DASHBOARDS, TaxType, VolumeUnitType, WeightUnitType };
